export default {
    methods: {
        addGradient (parent, type, stops, attributes) {
            var defaultAttributes = {
                id: 'gradient',
                x1: '0',
                y1: '0',
                x2: '0',
                y2: '1',
                spreadMethod: 'pad'
            }

            var gradient = parent.append(type).attrs(Object.assign({}, defaultAttributes, attributes || {}))

            for (let stop of stops) {
                gradient.append('stop')
                    .attrs({
                        offset: stop.offset,
                        'stop-color': stop.color
                    })
            }
        },
        appendRadialTick (object, angle, distance, length, stroke) {
            object.append('line')
                .attrs({
                    x1: -distance,
                    y1: 0,
                    x2: length - distance,
                    y2: 0,
                    stroke: stroke,
                    transform: 'rotate(' + angle + ')'
                })
        },
        appendRadialAxisLabel (object, label, radius, angle, fill) {
            object.append('g')
                .attrs({
                    class: 'axisLabel',
                    transform: 'rotate(' + angle + ')'
                })
                .append('text')
                .attrs({
                    fill: fill,
                    x: -radius + 'px',
                    y: '.5em',
                    transform: 'rotate(-90 ' + -radius + ' 0)'
                })
                .text(label)
        }
    }
}



// WEBPACK FOOTER //
// ./src/mixins/SvgHelper.js